"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCoaGroup = exports.buildCoaTree = exports.buildCoaGroupTxns = exports.buildCoaGroupBalance = void 0;
const immutable_1 = require("immutable");
// add child coa txn total in parent coa node
const buildCoaGroupBalance = (rootCoaNode) => {
    if (rootCoaNode.subgroups) {
        rootCoaNode.subgroups.forEach((coaNode) => {
            rootCoaNode.childTotal += (0, exports.buildCoaGroupBalance)(coaNode); // eslint-disable-line no-param-reassign
        });
    }
    return rootCoaNode.childTotal + rootCoaNode.total;
};
exports.buildCoaGroupBalance = buildCoaGroupBalance;
// add child coa txn in parent coa node
const buildCoaGroupTxns = (rootCoaNode) => {
    if (rootCoaNode.subgroups) {
        rootCoaNode.subgroups.forEach((coaNode) => {
            const childItems = rootCoaNode.childTxns ? rootCoaNode.childTxns : [];
            rootCoaNode.childTxns = [...childItems, ...(0, exports.buildCoaGroupTxns)(coaNode)]; // eslint-disable-line no-param-reassign
        });
    }
    const childTxns = rootCoaNode.childTxns ? rootCoaNode.childTxns : [];
    return [...childTxns, ...rootCoaNode.txns];
};
exports.buildCoaGroupTxns = buildCoaGroupTxns;
// build coa tree
const buildCoaTree = (coaHashTable, coaDataTree, coaGroup, txn, splitTxnAmount) => {
    coaGroup.forEach((coa) => {
        if (!coaHashTable[coa.categoryId]) {
            coaHashTable[coa.categoryId] = Object.assign(Object.assign({}, coa), { subgroups: [] }); // eslint-disable-line no-param-reassign
        }
        else { // Ignore duplicate coa node
            coa.ignore = true; // eslint-disable-line no-param-reassign
            coaHashTable[coa.categoryId].isTxnCategory = coa.isTxnCategory; // eslint-disable-line no-param-reassign
        }
    });
    coaGroup.forEach((coa) => {
        var _a, _b;
        if (coa.parentCategoryId) { // add child coa node in tree
            const coaNode = coaHashTable[coa.categoryId];
            // find node if it's existing in coa group
            const coaObject = !coa.ignore ? coaNode :
                (_a = coaHashTable[coa.parentCategoryId].subgroups) === null || _a === void 0 ? void 0 : _a.find((dataItem) => dataItem.categoryId === coaNode.categoryId);
            if (coaNode.isTxnCategory) { // update txn
                coaObject === null || coaObject === void 0 ? void 0 : coaObject.txns.push(txn);
                // @ts-expect-error - 'coaObject' is possibly 'undefined'.ts(18048)
                coaObject.total += splitTxnAmount;
            }
            if (!coa.ignore) { // add to tree if its new coa
                (_b = coaHashTable[coa.parentCategoryId].subgroups) === null || _b === void 0 ? void 0 : _b.push(coaNode);
            }
        }
        else { // Add root coa node in tree
            const coaNode = coaHashTable[coa.categoryId];
            if (coaNode.isTxnCategory) { // update txn
                coaNode.txns.push(txn);
                coaNode.total += splitTxnAmount;
            }
            if (!coa.ignore) { // add to tree if its new coa
                coaDataTree.push(coaNode);
            }
        }
    });
};
exports.buildCoaTree = buildCoaTree;
const addNodeData = (coaDataMap, coaNode, txns, total) => {
    var _a;
    // eslint-disable-next-line no-param-reassign
    coaDataMap[(_a = coaNode === null || coaNode === void 0 ? void 0 : coaNode.groupKey) !== null && _a !== void 0 ? _a : -1] = {
        groupKey: coaNode === null || coaNode === void 0 ? void 0 : coaNode.groupKey,
        categoryId: coaNode.categoryId,
        txns: (0, immutable_1.List)(txns),
        total,
        subgroups: {},
    };
};
const buildCoaGroup = (coaDataTree, coaDataMap) => {
    coaDataTree.forEach((coaNode) => {
        var _a;
        const groupKey = (_a = coaNode === null || coaNode === void 0 ? void 0 : coaNode.groupKey) !== null && _a !== void 0 ? _a : 'undefined';
        const childTxns = coaNode.childTxns ? coaNode.childTxns : [];
        addNodeData(coaDataMap, coaNode, ([...coaNode.txns, ...childTxns]), (coaNode.total + coaNode.childTotal));
        if (coaNode.total) { // Add root coa in hierarchy
            addNodeData(coaDataMap[groupKey].subgroups, coaNode, ([...coaNode.txns]), coaNode.total);
        }
        (0, exports.buildCoaGroup)(coaNode.subgroups, coaDataMap[groupKey].subgroups);
    });
};
exports.buildCoaGroup = buildCoaGroup;
